import { Data } from '@taraai/types';

export const hasImportFinished = (importData: Data.Import): boolean =>
  importData.processedItemsCount === importData.totalItemsCount;

export const hasImportFailed = (pendingImport: Data.Import): boolean => pendingImport.errorsCount !== 0;
